import { handleActions, createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';
import cookie from 'cookie';
import { authTokenLocalStorage } from './selectors';

// Actions
export const actions = mapActions([
    'LOGIN_FORM',
    'SET_PASSWORD_FORM',
    'SET_PASSWORD_SUCCESS',
    'RESET_PASSWORD_FORM',
    'SAVE_AUTH_TOKEN',
    'CLEAR_AUTH_TOKEN',
    'LOGIN_OKTA_TOKEN',
    'LOGIN_SUCCESS',
    'NAVIGATE_TO_OKTA_BROKER'
], 'AUTH');


// Action Creators
export const submitLoginForm = createFormAction(actions.LOGIN_FORM);
export const submitSetPasswordForm = createFormAction(actions.SET_PASSWORD_FORM);
export const submitSetPasswordSuccess = createAction(actions.SET_PASSWORD_SUCCESS);
export const submitResetPasswordForm = createFormAction(actions.RESET_PASSWORD_FORM);
export const saveAuthToken = createAction(actions.SAVE_AUTH_TOKEN);
export const clearAuthToken = createAction(actions.CLEAR_AUTH_TOKEN);
export const loginSuccess = createAction(actions.LOGIN_SUCCESS);
export const loginOktaToken = createAction(actions.LOGIN_OKTA_TOKEN);
export const navigateToOktaBroker = createAction(actions.NAVIGATE_TO_OKTA_BROKER);

// Reducers
const parsedCookie = cookie.parse(document.cookie);
const initialState = {
    oktaToken: parsedCookie.goodwayAuthToken,
    authToken: authTokenLocalStorage(),
    loggedIn: false
};

initialState.loggedIn = !!initialState.authToken;

export default handleActions({
    [actions.SAVE_AUTH_TOKEN]: (state, action) => update(state, {
        loggedIn: { $set: true },
        authToken: { $set: action.payload.token }
    }),
    [actions.CLEAR_AUTH_TOKEN]: state => update(state, {
        loggedIn: { $set: false },
        authToken: { $set: null }
    })
}, initialState);



// WEBPACK FOOTER //
// ./src/services/auth/duck.js